module.exports = __webpack_public_path__ + "afb3085766761814ccc9ce6a3f7615c1.png";